import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { MarkTabs, InformationFlow } from 'ThreeTerminal_mobile_dynamic';
import { getSpecificList } from '../../../../services/api';
import Ad from '@ifeng/ui_pc_ad';
import { getUrlSecretId } from '@Container/common/client/utils/utils';
import errorBoundary from '@ifeng/errorBoundary';

class RelateVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        title: PropTypes.string,
        ad: PropTypes.object,
        isVideoShare: PropTypes.bool,
        wxLaunch: PropTypes.object,
    };

    state = {
        relateVideoDataArr: [],
    };

    /**
     * 渲染网页布局
     */
    async componentDidMount() {
        const { content, title } = this.props;

        try {
            const data = await getSpecificList(content, 'share_relate_recom_doc', 4, 'video');

            if (data) {
                this.formalData(data);
            }
        } catch (e) {
            console.error(e);
        }
    }

    formalData(data) {
        const { content, isVideoShare, wxLaunch } = this.props;
        const filterData = data.filter(item => {
            return item.type === 'phvideo';
        });
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822846570',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8798',
              };

        const listData = filterData.slice(0, 4).map((item, index) => ({
            id: item.id || item.commentsUrl,
            _id: (item.link && item.link.weburl && getUrlSecretId(item.link.weburl)) || '',
            title: item.title || '',
            url: item.link.weburl || '',
            isVideoShare,
            type: 'video',
            thumbnails: {
                image: [
                    {
                        bytes: 277,
                        width: '340',
                        url: item.thumbnail || '',
                        height: '188',
                    },
                ],
            },
            newstype: 'phvideo',
            allcount: 0,
            length: (item.phvideo && item.phvideo.length) || '',
            duration: (item.phvideo && item.phvideo.length) || '',
            twoimage: 1,
            callUp: 1,
            kind: 'share01',
            clickCount: {
                behavior: 'action',
                type: 'click',
                other: {
                    to: item.commentsUrl || item.documentId,
                    ref: `ucms_${content}`,
                    rnum: index,
                    tag: 't6',
                    kind: 'article',
                    url: item.link && encodeURIComponent(item.link.weburl),
                },
            },
            downloads,
            wxLaunchType: wxLaunch.wxLaunchType,
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
        }));

        const listDataArr = [
            {
                type: 'twoimage',
                data: listData.slice(0, 2),
            },
            {
                type: 'twoimage',
                data: listData.slice(2, 4),
            },
        ];

        this.setState({
            relateVideoDataArr: listDataArr,
        });
    }

    render() {
        /**
         * 组件分发数据
         */
        const { relateVideoDataArr } = this.state;
        const { ad } = this.props;
        const markTabsObj = {
            title: '推荐视频',
        };

        return (
            relateVideoDataArr.length > 0 && (
                <section className={styles.relateVideo}>
                    <MarkTabs content={markTabsObj} />
                    <InformationFlow isCount={false} content={relateVideoDataArr} isDisplayLoadingMore={false} />
                    {ad && <Ad content={ad} />}
                </section>
            )
        );
    }
}

export default errorBoundary(RelateVideo);
